import PageWrapper from '../../components/PageWrapper';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import bannerImg from '../../assets/images/allDoc.png';
import team from '../../assets/images/landingpage/medicalteam.png';

const Feature = () => {
  const boxes = [
    {
      title: 'Expert Medical Care',
      text: 'Highly qualified professionals delivering accurate diagnosis and treatment.',
    },
    {
      title: 'Advanced Technology',
      text: 'Modern medical equipment ensuring precision and safety.',
    },
    {
      title: 'Patient-Centric Approach',
      text: 'Compassionate care focused on patient comfort and recovery.',
    },
    {
      title: '24/7 Emergency Support',
      text: 'Round-the-clock medical assistance when you need it most.',
    },
  ];

  return (
    <PageWrapper title="Feature">
      {/* ================= FEATURE SECTION ================= */}
      <section className="py-3">
        <Container className="px-3">
          <Row className="align-items-center">
            <Col lg={4} md={12}>
              <div className="fw-bold small mb-2">Feature</div>

              <h2 className="fw-bold mb-3">
                Our Practice Excellent <br />
                Care, Humane Principles
              </h2>

              <p className="text-muted mb-4">
                We provide trusted healthcare services with empathy, innovation,
                and patient safety at the core of our practice.
              </p>

              <Image
                src={bannerImg}
                fluid
                className="rounded shadow-sm d-block mx-auto py-2"
                style={{ width: '100%', maxWidth: '350px' }}
              />
            </Col>
            <Col lg={7}>
              <Row className="g-4">
                {boxes.map((box, index) => (
                  <Col md={6} key={index}>
                    <Card className="h-100 p-4 border-0 shadow-sm">
                      <div className="d-flex align-items-center mb-3">
                        <span className="fw-bold fs-5  me-2">
                          {String(index + 1).padStart(2, '0')}
                        </span>
                        <span
                          style={{
                            width: '36px',
                            height: '3px',
                            backgroundColor: '#2A8C8C',
                            borderRadius: '4px',
                          }}
                        />
                      </div>

                      <h6 className="fw-bold mb-2">{box.title}</h6>

                      <p className="text-muted small mb-0">{box.text}</p>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ================= VISION & MISSION ================= */}
      <section className="py-5 bg-light px-4">
        <Container>
          <Row className="align-items-center">
            <Col lg={4}>
              <Row className="g-4">
                <Col sm={6}>
                  <Card className="h-100  shadow-sm rounded-4 text-center p-3 ">
                    <Image
                      src={team}
                      alt="Vision Icon"
                      width={28}
                      height={28}
                      className="mb-3 mx-auto"
                    />
                    <h6 className="fw-semibold mb-1">Vision</h6>
                    <p className="text-muted small mb-0">
                      To deliver ethical, accessible and world-class healthcare.
                    </p>
                  </Card>
                </Col>

                <Col sm={6}>
                  <Card className="h-100  shadow-sm rounded-4 text-center p-3">
                    <Image
                      src={team}
                      alt="Mission Icon"
                      width={28}
                      height={28}
                      className="mb-3 mx-auto"
                    />
                    <h6 className="fw-semibold mb-1">Mission</h6>
                    <p className="text-muted small mb-0">
                      Improving lives through compassionate medical excellence.
                    </p>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col lg={8} className="ps-lg-4 mt-4 mt-lg-0">
              <span className="primary-class fw-semibold small d-block mb-2">
                Vision & Mission
              </span>

              <h2 className="fw-bold lh-sm mb-3">
                Transforming Healthcare <br />
                Through Empathetic Innovation
              </h2>

              <p className="text-muted mb-0" style={{ maxWidth: '520px' }}>
                Our mission and vision guide us to provide advanced,
                patient-first medical services with trust and transparency.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </PageWrapper>
  );
};

export default Feature;
